/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOnboardingEvent } from '../../models/api-response-onboarding-event';
import { OnboardingEvent } from '../../models/onboarding-event';

export interface Track$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: OnboardingEvent
}

export function track(http: HttpClient, rootUrl: string, params: Track$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOnboardingEvent>> {
  const rb = new RequestBuilder(rootUrl, track.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOnboardingEvent>;
    })
  );
}

track.PATH = '/v1/api/onboarding-event-client/track';
